export default __webpack_public_path__ + "static/media/tag-grey.5226fe7e.svg";